import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { LoginInfoService } from '@pg-app/auth/services/login-info.service';

@Injectable({
  providedIn: 'root'
})
export class LoginStep3Guard implements CanActivate {
  constructor(private loginInfo: LoginInfoService, private router: Router) {}
  canActivate() {
    if (this.loginInfo.currentUserStep === 'step-3') {
      return true;
    }
    this.router.navigate(['/']);
    return false;
  }
}
